{{#each this}}
<li class="content__item" id="{{id}}">
    <div class="content__film-image">
<img src="{{poster_path}}" loading="lazy" alt="{{title}}" class="card-gallery-image"/>
    </div>

<div class="content__film-info">
    <p class="content__film-name">{{title}}</p>
    <p class="content__film-subscription">{{genre_ids}} &#10072; {{release_date}}<span class="accent-box accent-box-rating js-span-vote visually-hidden">{{vote_average}}</span></p>    
</div>
</div>
</li>
{{/each}}